export default __webpack_public_path__ + "static/media/employer.e2310e2f.svg";